import { DOMHelper } from "../../Helpers/DOMHelper.js";
import { ShiftDatalayer } from "../../Datalayer/ShiftDatalayer.js";
import { AdobeDtmDatalayer } from "../../Datalayer/AdobeDtmDatalayer.js";

export class CTAButton {
    constructor(app, vehicle, options, containerElement) {
        this.app = app;
        this.vehicle = vehicle;
        this.paymentData = null;
        this.subPmDrs = null;
        this.customClickHandler = null
        this.containerElement = containerElement || null;
        //OPTIONS
        this.options = this.defaultOptions();
        Object.assign(this.options, options || {});
    }

    init(paymentData, force) {
        force = force || false;
        if(!force){
            paymentData = paymentData || this.paymentData;
            if(!paymentData) return;//skip
            // if(paymentData.expired) return;//skip expired, remove from endpoint?
            //if(!paymentData.allowed) return;//skip not allowed, remove from endpoint?
        }
        

        this.paymentData = paymentData;
        this.addHtml();
        this.addHandlers();

        this.shiftDatalayer = new ShiftDatalayer(this.app.pmdrs, this.vehicle);
        this.shiftDatalayer.init();
        this.addShiftDataLayerHandlers();

        //ADOBE DTM DATALAYER
        this.adobeDtmDatalayer = new AdobeDtmDatalayer(this.app.pmdrs, this.vehicle);
        if(this.adobeDtmDatalayer.init()){
            this.addAdobeDtmDataLayerHandlers();
        }
    }

    defaultOptions() {
        return {
            hide: false
        }
    }

    addHtml(){                     
        var template = `<div class="pmdrs-widget-container" id ="pmdrs_widget_{{vin}}"></div>

<div class="pmdrs pmdrs-cta-button {{additionalClass}}" role="button" tabindex="0"
style="background-color: {{bgColor}}">
<i class="pmdrs-fa pmdrs-fa-shopping-cart"></i>
<span>{{text}}</span>
<div class="pmdrs-loading-wrapper cta-button-loading" style="display: none"><div class="lds-dual-ring"></div></div>
</div>`;
        var additionalClass = "";
        if(this.options.hide){//hide
            additionalClass += 'd-none';
        }
        template = template
            .replaceAll("{{bgColor}}", this.app.siteSettings.vlp_btn_color || "rgb(35,144,255)")
            .replaceAll("{{text}}", this.app.siteSettings.vlp_btn_text || "Personalize Deal Now")
            .replaceAll("{{vin}}", this.vehicle.vin)            
            .replaceAll("{{additionalClass}}", additionalClass);            


        const container = this.getContainerElement();
        if (!container) return;
        container.querySelectorAll('.pmdrs-cta-button').forEach(el => el.remove());
        container.insertAdjacentHTML("beforeend", template);
    }

    showLoading(){        
        const btn = this.getButtonElement();
        var loading = btn.querySelector(".cta-button-loading");
        loading.style.display = "block";        
        // Namespaced: host sites ship bare .loading rules (pm-motors-plugin autocheck.css turns any
        // .loading into a 120px spinning circle), so a generic class name restyles our button.
        DOMHelper.addClass(btn, 'pmdrs-loading');
    }

    hideLoading(){
        const btn = this.getButtonElement();
        var loading = btn.querySelector(".cta-button-loading");
        loading.style.display = "none";        
        DOMHelper.removeClass(btn, 'pmdrs-loading');
    }

    setBtnClickCallback(clickHandler){
        this.customClickHandler = clickHandler;
    }

    click(dealType){
        const btn = this.getButtonElement();

        if(this.customClickHandler){
            this.customClickHandler();
            return;
        }

        if(this.subPmDrs){//if already exists only open it
            if(dealType){
                this.subPmDrs.frontApp.dealPage.paymentSection
                    .selectDealType(dealType, false)
                    .updateMyPaymentValues();    
            }
            
            this.subPmDrs.frontApp.dealModal.show();
            this.app.lastFrontApp = this.subPmDrs.frontApp;
            return;
        }
        this.showLoading();
        //create sub DRS
        this.subPmDrs = new PMDRS(this.app.pmdrs.config);
        var showTabsWidget = false && this.app.pmdrs.config.accountId == 'speeddra2';
        var frontAppConfig = {
            elementId: "pmdrs_widget_" + this.vehicle.vin,
            vehicle: this.vehicle,                
            recaptchaSiteKey: this.app.config.recaptchaSiteKey,
            hideWidget:  !showTabsWidget//showing tabs 
        };

        let createCJCTA = function(subFrontApp) {
            let data = {
                sessionId: subFrontApp.pmdrs.frontApp.pmDRSDatalayer.getSessionId(),
                siteToken: subFrontApp.pmdrs.config.accountId
            };

            subFrontApp.pmdrs.pmCustomerAPI.createCustomerJourneyCTA(data, 
                (response) => {
                    console.log("Creating CJ status partial-cta-click from CTAButtton");
                    response = JSON.parse(response);
                    subFrontApp.dealPage.customerJourneyId = response.id;
                    console.log(response);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
        var $this = this;
        let openFrontApp = function() {
            frontAppConfig.vehicle = $this.vehicle;
            var subFrontApp = $this.subPmDrs.createFrontApp(frontAppConfig);
            subFrontApp.setDefaultDealType(dealType);
            subFrontApp.setInitCallBack(()=>{
                $this.hideLoading();
                if(showTabsWidget) DOMHelper.addClass(btn, 'd-none');
                createCJCTA(subFrontApp);
            });
            $this.app.lastFrontApp = subFrontApp;
        };

        // Third-party sites (pmdra-embed.js) have no pm-motors-plugin accessories endpoint:
        // keep whatever accessories the vehicle already came with. On DealerOn the request
        // answered 406 and the button kept spinning.
        if (!this.app.pmdrs.isPmWordpressHost()) {
            openFrontApp();
            return;
        }

        this.subPmDrs.pmDealersite.getAccessoriesByVin(this.vehicle.vin,
            (accessories)=>{
                $this.vehicle.accessories = accessories;
                openFrontApp();
            },
            ()=>{
                console.error("PMDRS CTA Button: error getting accessories from dealersite");
                openFrontApp();
            }
        )
    }

    addHandlers() {
        var $this = this;
        const btn = this.getButtonElement();
        DOMHelper.addHandler(btn, "click", (e) => {
            $this.click($this.paymentData?.dealType)
        });
        // a div with role="button": Enter/Space work like on a real button
        DOMHelper.addHandler(btn, "keydown", (e) => {
            if (e.key !== "Enter" && e.key !== " ") return;
            e.preventDefault();
            $this.click($this.paymentData?.dealType);
        });
    }    

    addShiftDataLayerHandlers(){
        var $this = this;
        var dataLayer = this.shiftDatalayer;        

        //moved to modal shown
        // DOMHelper.addHandler(
        //     this.getButtonElement(),
        //     "click", 
        //     (event) => {   
        //         let args = {withClick:true, dealType: $this.paymentData?.dealType };
        //         dataLayer.fireEvent('drPageView', args);                                
        //     }
        // );

    }

    addAdobeDtmDataLayerHandlers(){
        var $this = this;
        var dataLayer = this.adobeDtmDatalayer;        

        DOMHelper.addHandler(
            this.getButtonElement(),
            "click", 
            (event) => {   
                dataLayer.fireEvent('buttonClick', {btnText: $this.app.siteSettings.vlp_btn_text});            
            }
        );

    }

    setContainerElement(element) {
      this.containerElement = element;
      return this;
    }

    getContainerElement() {
      if (this.containerElement) return this.containerElement;
      // Try with VIN first
      let containerSelector = `.${this.app.config.ctaButtonClass}[data-vin="${this.vehicle.vin}"]`;
      let containerElement = document.querySelector(containerSelector);

      // Fallback to only the class if not found
      if (!containerElement) {
        containerSelector = `.${this.app.config.ctaButtonClass}`;
        containerElement = document.querySelector(containerSelector);

        if (!containerElement) {
            containerElement = document.querySelector(this.app.getSelector(''))

            if(!containerElement){
                console.error("Missing container for selector: " + containerSelector);
            }
        }
      }

      return containerElement;
    }


    getButtonElement() {
        return this.getContainerElement().querySelector(".pmdrs-cta-button");
    }
}
